import React from 'react';
import {
  Image, ScrollView, Text, View,
} from 'react-native-web';
import { xlateText } from '../../../../utils/Utils';
import { getImageByKey } from '../../../../utils/ImagesManagementUtils';
import { Android, bank_logo } from '../../../../utils/DictionaryManagementUtils';
import TopHorizontalPhonePage from './TopHorizontalPhonePage';
import LargeBtnWithFilling from '../ButtonComponent/LargeBtnWithFilling';

//= ========================================================================
const BottomSquareCard = ({
  globJSON, simPlatform,
}) => {
  const { expand_message } = globJSON.configurations.launch;

  const myStyles = {
    iMsgTitle: {
      width: 190,
      fontFamily: 'Rubik-Regular',
      fontSize: 13,
      color: '#001a2f',
      alignSelf: 'center',
      textAlign: 'center',
      paddingVertical: 15,
    },
    bankLogo: {
      width: 67,
      height: 35,
      marginLeft: 23,
    },
    TopHorizontalPhonePage: {
      marginTop: 5,
    },
    imsg: {
      resize: 'cover',
      height: 224,
      marginTop: 305,
      width: 240,
    },
    viewAll: {
      width: '100%',
      alignSelf: 'center',
      position: 'absolute',
      flexDirection: 'column',
      background: 'white',
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      height: simPlatform === Android ? 197 + 48 - 12 : 197,
      marginTop: 380,
    },
    LargeBtnWithFillingStyle: {
      marginTop: 9,
    },
  };
  return (
    <ScrollView
      style={myStyles.viewAll}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >
      <View style={myStyles.TopHorizontalPhonePage}>
        <TopHorizontalPhonePage
          globJSON={globJSON}
        />
      </View>
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.bankLogo}
        source={getImageByKey(globJSON.configurations.services.menu.bank_logo, bank_logo)}
      />
      <Text style={myStyles.iMsgTitle}>
        {xlateText(expand_message.imsg_expand_title, globJSON)}
      </Text>
      <View style={myStyles.LargeBtnWithFillingStyle}>
        <LargeBtnWithFilling
          globJSON={globJSON}
          simPlatform={simPlatform}
          shortBtn
          inputText={expand_message.imsg_expand_button}
        />
      </View>
    </ScrollView>
  );
};
export default BottomSquareCard;
